import React, { useEffect, Fragment, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import Select from "react-select";
import Avatar from "@components/avatar";
import blankImage from "@src/assets/images/avatars/avatar-blank.png";
import {
  ArrowRight,
  File,
  RefreshCw,
  Trash,
  Trash2,
  Video,
  X,
  Eye,
} from "react-feather";
import PDF from "@src/assets/images/icons/pdf1.png";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Spinner,
  FormGroup,
  Input,
  Form,
  CustomInput,
  Alert,
  Table,
} from "reactstrap";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  getCountries,
  getRegions,
  getStates,
  getCities,
  locationFromZipCodeAction,
  locationFromZipCodeActionReset,
} from "@src/views/apps/opportunitiesBrands/store/actions/index";
import {
  getPrimarilyGoals,
  getBrandCompanySelectValues,
  getBrandGoalsSelectValues,
  handleLogout,
} from "@store/actions/auth";
import {
  getProfile,
  getProfileReset,
  updateProfile,
  updateProfileReset,
  removeMediaFromProfile,
  deleteAccount,
  deleteAccountReset,
  syncFollowers,
  syncFollowersReset,
} from "@store/actions/RDActions";
import { useHistory } from "react-router";
import Uploader from "@src/views/components/Uploader";
import ImageViewer from "@src/views/components/ImageViewer";
import PdfViewer from "@src/views/components/PdfViewer";
import VideoPlayer from "@src/views/components/VideoPlayer";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "@styles/react/libs/editor/editor.scss";
import "@styles/base/plugins/forms/form-quill-editor.scss";
import CustomLabel from "@src/views/components/CustomLabel";
import {
  confirmAlert,
  successAlert,
  errorAlert,
} from "@src/views/components/CustomAlerts";

const RDEditProfile = () => {
  const genderOption = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Non-Binary", label: "Non-Binary" },
    { value: "Transgender", label: "Transgender" },
  ];
  const yearsInPracticeOptions = [
    { value: "Emerging RD (0–2 years)", label: "Emerging RD (0–2 years)" },
    { value: "Early Career (3–5 years)", label: "Early Career (3–5 years)" },
    { value: "Mid-Career (6–10 years)", label: "Mid-Career (6–10 years)" },
    { value: "Seasoned RD (11–20 years)", label: "Seasoned RD (11–20 years)" },
    { value: "Veteran RD (21+ years)", label: "Veteran RD (21+ years)" },
  ];

  const followersOptions = [
    { value: "0–5K", label: "0 – 5K" },
    { value: "5K–10K", label: "5K – 10K" },
    { value: "10K–50K", label: "10K – 50K" },
    { value: "50K - 100K", label: "50K – 100K" },
    { value: "100,001–500,000", label: "100K – 500K" },
    { value: "500,001+", label: "500K+" },
  ];

  const rdOption = [
    { value: "RD", label: "RD" },
    { value: "RD2Be", label: "RD2Be" },
    { value: "Other", label: "Other" },
  ];

  const hearAboutOption = [
    { value: "SocialMedia", label: "Social Media" },
    { value: "Colleague", label: "Colleague" },
    { value: "Other", label: "Other" },
  ];

  const licenceOption = [
    { value: "CDR", label: "CDR Number" },
    { value: "DOC", label: "Proof of Certification" },
  ];

  const onlyCharRegex = /^[aA-zZ\s]+$/;

  const urlRegex =
    /([hH][tT]{2}[pP][sS]?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

  const CERTIFICATE_FORMATS = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/pdf",
  ];

  const CERTIFICATE_MAX_SIZE = 5 * 1024 * 1024;

  const ALLOWED_PROFILE_IMAGES = ["png", "jpeg", "jpg"];

  const PROFILE_PIC_FORMATS = ["image/png", "image/jpeg", "image/jpg"];

  const PROFILE_PIC_MAX_SIZE = 2 * 1024 * 1024;

  const history = useHistory();

  const userData = JSON.parse(
    localStorage.getItem(`${process.env.REACT_APP_USERDATA}`),
  );

  const [country, setCountry] = useState([]);
  const [region, setRegion] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [profileViewLink, setProfileViewLink] = useState("");
  const [certificateViewLink, setCertificateViewLink] = useState("");
  const [mediaDocs, setMediaDocs] = useState([]);
  const [showUploader, setShowUploader] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [imageViewer, setImageViewer] = useState({ show: false, src: "" });
  const [pdfViewer, setPdfViewer] = useState({
    show: false,
    url: "",
    filename: "",
  });
  const [videoPlayer, setVideoPlayer] = useState({
    show: false,
    url: "",
    filename: "",
  });
  const [aboutCompanyEditorState, setAboutCompanyEditorState] = useState(null);
  const prevSocialUrls = useRef(null);
  // Holds the latest URLs that arrived while a sync was already in-flight.
  // A useEffect fires one follow-up sync with these values once loading finishes.
  const pendingUrlsRef = useRef(null);

  const dispatch = useDispatch();

  const {
    brandGoalsSelectValues,
    brandCompanySelectValues,
    rdPrimarilyGoalsValues,
  } = useSelector((state) => state.auth);

  const { countries, regions, states, cities } = useSelector(
    (store) => store.brandsOppoprunities,
  );

  const {
    getProfileLoading,
    getProfileData,
    getProfileError,

    updateProfileLoading,
    updateProfileData,
    updateProfileError,

    deleteAccountLoading,
    deleteAccountData,
    deleteAccountError,

    syncFollowersLoading,
    syncFollowersData,
    syncFollowersError,
  } = useSelector((store) => store.rdReducer);

  const { locationFromZipCodeLoading, locationFromZipCodeData } = useSelector(
    (store) => store.locationFromZipCodeReducer,
  );

  const updateProfileForm = useFormik({
    initialValues: {
      email: "",
      firstLastName: "",
      profilePicture: "",
      registeredDietitian: "",
      otherRD: "",
      licenceType: "",
      gender: "",
      yearsInPractice: "",
      followers: "",
      cdrNo: "",
      proofOfCertification: "",
      about: "",
      attributes: "",
      workIn: "",
      specializeIn: "",
      website: "",
      facebook: "",
      secondaryFacebook: "",
      instagram: "",
      secondaryInstagram: "",
      twitter: "",
      pinterest: "",
      linkedIn: "",
      tiktok: "",
      postalCode: "",
      country: "",
      regions: "",
      state: "",
      city: "",
      mainGoal: "",
      companyValues: "",
      specialDiet: "",
      foodCategory: "",
      primarilyInterested: "",
      hearAbout: "",
      otherPlatform: "",
    },
    validationSchema: yup.object().shape(
      {
        email: yup
          .string()
          .email("Email format is invalid.")
          .required("This field is required"),
        firstLastName: yup
          .string()
          .trim()
          .required("This field is required")
          .matches(onlyCharRegex, "Only alphabets are allowed."),
        profilePicture: yup
          .mixed()
          .test(
            "fileFormat",
            "Picture is empty or invalid. Only PNG, JPEG, JPG are allowed.",
            (value) =>
              !value || (value && PROFILE_PIC_FORMATS.includes(value.type)),
          )
          .test(
            "fileSize",
            "Picture size too large. Max 2MB.",
            (value) => !value || (value && value.size <= PROFILE_PIC_MAX_SIZE),
          ),
        registeredDietitian: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        otherRD: yup.string().when("registeredDietitian", {
          is: (e) => e && e.value === "Other",
          then: yup.string().trim().required("This field is required"),
        }),
        licenceType: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        gender: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        yearsInPractice: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        cdrNo: yup.string().when("licenceType", {
          is: (e) => e?.value === "CDR",
          then: yup.string().trim().required("CDR Number is required."),
          otherwise: yup.string(),
        }),
        proofOfCertification: yup
          .mixed()
          .when("licenceType", (licenceType, schema, certificate) => {
            if (
              (licenceType?.value === "DOC" && !certificateViewLink) ||
              certificate.value
            ) {
              return schema
                .required("Certificate is required.")
                .test(
                  "fileFormat",
                  "Certificate is empty or invalid. Only allowed PNG, JPG, JPEG, PDF",
                  (value) => value && CERTIFICATE_FORMATS.includes(value.type),
                )
                .test(
                  "fileSize",
                  "Certificate size too large. Max 5MB.",
                  (value) => value && value.size <= CERTIFICATE_MAX_SIZE,
                );
            }
          }),
        about: yup.string().trim().required("This field is required"),
        workIn: yup
          .array()
          .min(1, "Minimum 1 selection is required")
          .max(3, "Selection should be up to 3")
          .required("This field is required"),
        specializeIn: yup
          .array()
          .min(1, "Minimum 1 selection is required")
          .max(3, "Selection should be up to 3.")
          .required("This field is required"),
        website: yup.string().test("urlMatch", "Invalid URL.", (value) => {
          if (value && value.length > 0) {
            return urlRegex.test(value);
          }
          return true;
        }),
        facebook: yup.string().test("urlMatch", "Invalid URL.", (value) => {
          if (value && value.length > 0) {
            return urlRegex.test(value);
          }
          return true;
        }),
        secondaryFacebook: yup
          .string()
          .test("urlMatch", "Invalid URL.", (value) => {
            if (value && value.length > 0) {
              return urlRegex.test(value);
            }
            return true;
          }),
        instagram: yup.string().test("urlMatch", "Invalid URL.", (value) => {
          if (value && value.length > 0) {
            return urlRegex.test(value);
          }
          return true;
        }),
        secondaryInstagram: yup
          .string()
          .test("urlMatch", "Invalid URL.", (value) => {
            if (value && value.length > 0) {
              return urlRegex.test(value);
            }
            return true;
          }),
        twitter: yup.string().test("urlMatch", "Invalid URL.", (value) => {
          if (value && value.length > 0) {
            return urlRegex.test(value);
          }
          return true;
        }),
        pinterest: yup.string().test("urlMatch", "Invalid URL.", (value) => {
          if (value && value.length > 0) {
            return urlRegex.test(value);
          }
          return true;
        }),
        linkedIn: yup.string().test("urlMatch", "Invalid URL.", (value) => {
          if (value && value.length > 0) {
            return urlRegex.test(value);
          }
          return true;
        }),
        tiktok: yup.string().test("urlMatch", "Invalid URL.", (value) => {
          if (value && value.length > 0) {
            return urlRegex.test(value);
          }
          return true;
        }),
        country: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        regions: yup.object().nullable(),
        state: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        city: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        mainGoal: yup.string().trim().required("This field is required"),
        primarilyInterested: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        companyValues: yup
          .array()
          .min(1, "Minimum 1 selection is required")
          .required("This field is required")
          .typeError("This field is required"),
        specialDiet: yup
          .array()
          .min(1, "Minimum 1 selection is required")
          .required("This field is required")
          .typeError("This field is required"),
        foodCategory: yup
          .array()
          .min(1, "Minimum 1 selection is required")
          .required("This field is required")
          .typeError("This field is required"),
        hearAbout: yup
          .object()
          .nullable()
          .required("This field is required")
          .typeError("This field is required"),
        otherPlatform: yup.string().when("hearAbout", {
          is: (e) => e && e.value === "Other",
          then: yup.string().trim().required("This field is required."),
          otherwise: yup.string(),
        }),
      },
      ["cdrNo", "proofOfCertification"],
    ),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("email", values.email);
      formData.append("name", values.firstLastName);
      if (values.profilePicture) {
        formData.append("profile_pic", values.profilePicture);
      }
      formData.append(
        "is_rd",
        values.registeredDietitian.value === "RD" ? 1 : 0,
      );
      formData.append(
        "is_dietetic_intern",
        values.registeredDietitian.value === "RD2Be" ? 1 : 0,
      );
      formData.append("is_other_rd", values.otherRD);
      formData.append("gender", values.gender.value);
      formData.append("years_in_practice", values.yearsInPractice.value);
      formData.append("followers", values.followers?.value ?? "");
      if (values.licenceType.value === "CDR") {
        formData.append("cdr_number", values.cdrNo);
      } else {
        formData.append("cdr_number", "");
      }
      if (values.proofOfCertification) {
        formData.append("proof_of_certification", values.proofOfCertification);
      }
      formData.append("about_me", values.about);
      if (values.attributes) {
        values.attributes.forEach((item) => {
          formData.append("personal_attributes_id[]", item.id);
        });
      }
      if (values.workIn) {
        values.workIn.forEach((item) => {
          formData.append("industry_id[]", item.id);
        });
      }
      if (values.specializeIn) {
        values.specializeIn.forEach((item) => {
          formData.append("specialty_id[]", item.id);
        });
      }
      formData.append("website", values.website);
      formData.append("facebook_url[]", values.facebook);
      formData.append("facebook_url[]", values.secondaryFacebook);
      formData.append("instagram_url[]", values.instagram);
      formData.append("instagram_url[]", values.secondaryInstagram);
      formData.append("twitter_url[]", values.twitter);
      formData.append("pinterest_url[]", values.pinterest);
      formData.append("linkedin_url[]", values.linkedIn);
      formData.append("tiktok_url[]", values.tiktok);
      formData.append("postal_code", values.postalCode);
      formData.append("country_id", values.country?.id ?? "");
      formData.append("region_id", values.regions?.id ?? "");
      formData.append("state_id", values.state?.id ?? "");
      formData.append("city_id", values.city?.id ?? "");
      formData.append("goals", values.mainGoal);
      if (values.companyValues) {
        values.companyValues.forEach((item) => {
          formData.append("values_id[]", item.id);
        });
      }
      if (values.specialDiet) {
        values.specialDiet.forEach((item) => {
          formData.append("special_diet_id[]", item.id);
        });
      }
      if (values.foodCategory) {
        values.foodCategory.forEach((item) => {
          formData.append("category_id[]", item.id);
        });
      }
      formData.append("primarily_interest", values.primarilyInterested.id);
      formData.append("here_about", values.hearAbout.value);
      formData.append("is_other_hear_about", values.otherPlatform);
      if (attachments?.length > 0) {
        attachments?.forEach((item) =>
          formData.append("media_documents[]", JSON.stringify(item)),
        );
      }
      dispatch(updateProfile(formData));
    },
  });

  useEffect(() => {
    if (countries) {
      setCountry(countries);
      dispatch({ type: "CLEAR_LOCATION_DATA_ON_SIGNUP" });
    }
    if (regions) {
      setRegion(regions);
      dispatch({ type: "CLEAR_LOCATION_DATA_ON_SIGNUP" });
    }
    if (states) {
      setState(states);
      dispatch({ type: "CLEAR_LOCATION_DATA_ON_SIGNUP" });
    }
    if (cities) {
      setCity(cities);
      dispatch({ type: "CLEAR_LOCATION_DATA_ON_SIGNUP" });
    }
  }, [countries, regions, states, cities]);

  useEffect(() => {
    if (locationFromZipCodeData?.data?.city_id) {
      const countryObj = {
        id: locationFromZipCodeData.data.country_id,
        value: locationFromZipCodeData.data.country_name,
        label: locationFromZipCodeData.data.country_name,
      };
      updateProfileForm.setFieldValue("country", countryObj);

      const regionObj = {
        id: locationFromZipCodeData.data.region_id,
        value: locationFromZipCodeData.data.region_name,
        label: locationFromZipCodeData.data.region_name,
      };
      updateProfileForm.setFieldValue("regions", regionObj);

      const stateObj = {
        id: locationFromZipCodeData.data.state_id,
        value: locationFromZipCodeData.data.state_name,
        label: locationFromZipCodeData.data.state_name,
      };
      updateProfileForm.setFieldValue("state", stateObj);

      const cityObj = {
        id: locationFromZipCodeData.data.city_id,
        value: locationFromZipCodeData.data.city_name,
        label: locationFromZipCodeData.data.city_name,
      };
      updateProfileForm.setFieldValue("city", cityObj);
      dispatch(locationFromZipCodeActionReset());
    }
  }, [locationFromZipCodeData]);

  useEffect(() => {
    if (getProfileData?.data) {
      const { data } = getProfileData;
      updateProfileForm.setFieldValue("email", data?.email);
      updateProfileForm.setFieldValue("firstLastName", data?.name);
      if (data?.profile_img) {
        setProfileViewLink(data?.profile_img);
      }
      if (data?.is_rd === 1) {
        updateProfileForm.setFieldValue("registeredDietitian", {
          value: "RD",
          label: "RD",
        });
      } else if (data?.is_dietetic_intern === 1) {
        updateProfileForm.setFieldValue("registeredDietitian", {
          value: "RD2Be",
          label: "RD2Be",
        });
      } else if (data?.other_rd) {
        updateProfileForm.setFieldValue("registeredDietitian", {
          value: "Other",
          label: "Other",
        });
        updateProfileForm.setFieldValue("otherRD", data?.other_rd);
      }
      updateProfileForm.setFieldValue("gender", {
        value: data?.gender,
        label: data?.gender,
      });
      if (data?.years_in_practice) {
        updateProfileForm.setFieldValue("yearsInPractice", {
          value: data?.years_in_practice,
          label: data?.years_in_practice,
        });
      }
      updateProfileForm.setFieldValue(
        "followers",
        data?.followers
          ? { value: data.followers, label: data.followers }
          : null,
      );
      if (data?.cdr_number) {
        updateProfileForm.setFieldValue("licenceType", {
          value: "CDR",
          label: "CDR Number",
        });
      } else if (data?.certification) {
        updateProfileForm.setFieldValue("licenceType", {
          value: "DOC",
          label: "Proof of Certification",
        });
      }
      updateProfileForm.setFieldValue("cdrNo", data?.cdr_number ?? "");
      setCertificateViewLink(data?.certification);
      setAboutCompanyEditorState(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(htmlToDraft(data?.about_me)),
        ),
      );
      updateProfileForm.setFieldValue("about", data?.about_me);
      updateProfileForm.setFieldValue(
        "attributes",
        data?.attributes?.personal_attributes,
      );
      updateProfileForm.setFieldValue("workIn", data?.attributes?.industry);
      updateProfileForm.setFieldValue(
        "specializeIn",
        data?.attributes?.speciality,
      );
      updateProfileForm.setFieldValue("website", data?.website ?? "");
      updateProfileForm.setFieldValue("facebook", data?.facebook ?? "");
      updateProfileForm.setFieldValue(
        "secondaryFacebook",
        data?.secondary_facebook_url ?? "",
      );
      updateProfileForm.setFieldValue("instagram", data?.instagram ?? "");
      updateProfileForm.setFieldValue(
        "secondaryInstagram",
        data?.secondary_instagram_url ?? "",
      );
      updateProfileForm.setFieldValue("twitter", data?.twitter ?? "");
      updateProfileForm.setFieldValue("pinterest", data?.pinterest ?? "");
      updateProfileForm.setFieldValue("linkedIn", data?.linkedin ?? "");
      updateProfileForm.setFieldValue("tiktok", data?.tiktok ?? "");
      updateProfileForm.setFieldValue("postalCode", data?.postal_code);
      updateProfileForm.setFieldValue("country", data?.location?.country ?? "");
      updateProfileForm.setFieldValue("regions", data?.location?.region ?? "");
      updateProfileForm.setFieldValue("state", data?.location?.state[0] ?? "");
      updateProfileForm.setFieldValue("city", data?.location?.city[0] ?? "");
      updateProfileForm.setFieldValue("mainGoal", data?.goals ?? "");
      updateProfileForm.setFieldValue(
        "companyValues",
        data?.interested_brands?.values,
      );
      updateProfileForm.setFieldValue(
        "specialDiet",
        data?.interested_brands?.special_diet,
      );
      updateProfileForm.setFieldValue(
        "foodCategory",
        data?.interested_brands?.category,
      );
      if (data?.primarily_brands?.id) {
        updateProfileForm.setFieldValue(
          "primarilyInterested",
          data?.primarily_brands ?? "",
        );
      }
      if (data?.hear_about) {
        updateProfileForm.setFieldValue("hearAbout", {
          value: data?.hear_about,
          label: data?.hear_about,
        });
      }
      if (data?.is_other_hear_about) {
        updateProfileForm.setFieldValue(
          "otherPlatform",
          data?.is_other_hear_about,
        );
      }
      if (data?.location?.country?.id) {
        // dispatch(getRegions(data?.location?.country?.id))
        dispatch(getStates(data?.location?.country?.id, true));
      }
      if (data?.location?.region?.id) {
        // dispatch(getStates(data?.location?.region?.id))
      }
      if (data?.location?.state[0]) {
        dispatch(getCities(data?.location?.state[0]?.id));
      }
      prevSocialUrls.current = {
        facebook_url: data?.facebook ?? "",
        secondary_facebook_url: data?.secondary_facebook_url ?? "",
        instagram_url: data?.instagram ?? "",
        secondary_instagram_url: data?.secondary_instagram_url ?? "",
        twitter_url: data?.twitter ?? "",
        tiktok_url: data?.tiktok ?? "",
        pinterest_url: data?.pinterest ?? "",
        linkedin_url: data?.linkedin ?? "",
      };
      setMediaDocs(data?.docs);
      dispatch(getProfileReset());
    }
  }, [getProfileData]);

  useEffect(() => {
    if (updateProfileError?.response?.status) {
      const errorHTML = ['<ul class="list-group">'];
      if (updateProfileError?.response?.data?.email) {
        errorHTML.push(
          `<li class="list-group-item font-small-3 text-danger">${updateProfileError?.response?.data?.email[0]}</li>`,
        );
      }
      if (updateProfileError?.response?.data?.name) {
        errorHTML.push(
          `<li class="list-group-item font-small-3 text-danger">${updateProfileError?.response?.data?.name[0]}</li>`,
        );
      }
      if (updateProfileError?.response?.data?.profile_pic) {
        errorHTML.push(
          `<li class="list-group-item font-small-3 text-danger">${updateProfileError?.response?.data?.profile_pic[0]}</li>`,
        );
      }
      if (updateProfileError?.response?.data?.proof_of_certification) {
        errorHTML.push(
          `<li class="list-group-item font-small-3 text-danger">${updateProfileError?.response?.data?.proof_of_certification[0]}</li>`,
        );
      }
      if (updateProfileError?.response?.data?.re_captcha_token) {
        errorHTML.push(
          `<li class="list-group-item font-small-3 text-danger">${updateProfileError?.response?.data?.re_captcha_token[0]}</li>`,
        );
      }
      errorHTML.push("</ul>");
      errorAlert(errorHTML.join(""));
      dispatch(updateProfileReset());
      updateProfileForm.setFieldValue("captchaToken", "");
    }
    if (updateProfileData?.success) {
      userData.name = updateProfileData?.data.name;
      userData.profile_image = updateProfileData?.data.profile_image;
      userData.profile_incomplete =
        updateProfileData?.profile_incomplete ?? false;
      userData.missing_fields = updateProfileData?.missing_fields ?? [];
      localStorage.setItem(
        `${process.env.REACT_APP_USERDATA}`,
        JSON.stringify(userData),
      );
      successAlert(
        '<p class="font-small-3 mt-2 mb-0 font-weight-bold">Your profile updated successfully.</p> <p class="font-small-3">Please wait a moment we are loading your changes.</p>',
        false,
      );
      dispatch(updateProfileReset());
      prevSocialUrls.current = getSocialUrls();
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  }, [updateProfileError, updateProfileData]);

  useEffect(() => {
    if (syncFollowersData?.success) {
      if (syncFollowersData.followers !== undefined) {
        updateProfileForm.setFieldValue(
          "followers",
          syncFollowersData.followers
            ? {
                value: syncFollowersData.followers,
                label: syncFollowersData.followers,
              }
            : null,
        );
      }
      if (syncFollowersData.followers) {
        successAlert(
          '<p class="font-small-3 mt-2 mb-0 font-weight-bold">Reach synced!</p><p class="font-small-3">Your total reach has been updated.</p>',
          false,
        );
      }
      dispatch(syncFollowersReset());
    }
    if (syncFollowersError) {
      errorAlert(
        '<p class="font-small-3">Could not sync followers. Please try again.</p>',
        false,
      );
      dispatch(syncFollowersReset());
    }
  }, [syncFollowersData, syncFollowersError]);

  // When the in-flight sync finishes, fire one more sync with the most-recent
  // URL state queued by handleSocialLinkBlur while loading was true.
  useEffect(() => {
    if (!syncFollowersLoading && pendingUrlsRef.current) {
      const urls = pendingUrlsRef.current;
      pendingUrlsRef.current = null;
      dispatch(syncFollowers(urls));
    }
  }, [syncFollowersLoading]);

  useEffect(() => {
    if (deleteAccountError?.response?.status) {
      errorAlert(`<p>${deleteAccountError?.response?.data?.message}</p>`);
      dispatch(deleteAccountReset());
    }
    if (deleteAccountData?.success) {
      successAlert("<p>Your account has been deleted successfully.</p>");
      dispatch(deleteAccountReset());
      dispatch(handleLogout());
      history.push("/login");
    }
  }, [deleteAccountData, deleteAccountError]);

  useEffect(() => {
    dispatch(getCountries());
    dispatch(getBrandCompanySelectValues());
    dispatch(getBrandGoalsSelectValues());
    dispatch(getPrimarilyGoals());
    dispatch(getProfile());
  }, []);

  // Returns current social URL values from Formik form state.
  const getSocialUrls = () => ({
    facebook_url: updateProfileForm.values.facebook,
    secondary_facebook_url: updateProfileForm.values.secondaryFacebook,
    instagram_url: updateProfileForm.values.instagram,
    secondary_instagram_url: updateProfileForm.values.secondaryInstagram,
    twitter_url: updateProfileForm.values.twitter,
    tiktok_url: updateProfileForm.values.tiktok,
    pinterest_url: updateProfileForm.values.pinterest,
    linkedin_url: updateProfileForm.values.linkedIn,
  });

  // Auto-sync followers when a social link URL changes on blur.
  // If a sync is already in-flight the latest URLs are stashed in pendingUrlsRef
  // so a follow-up sync fires as soon as the current one completes.
  const handleSocialLinkBlur = (e) => {
    updateProfileForm.handleBlur(e);
    if (!prevSocialUrls.current) return;
    const current = getSocialUrls();
    const hasChanged = Object.keys(current).some(
      (k) => current[k] !== prevSocialUrls.current[k],
    );
    if (!hasChanged) return;
    // Update baseline so the next blur compares against the latest state.
    prevSocialUrls.current = current;
    if (syncFollowersLoading) {
      // Stash latest URLs — the useEffect above will dispatch when loading ends.
      pendingUrlsRef.current = current;
      return;
    }
    dispatch(syncFollowers(current));
  };

  const getLocationFromPostalCode = (e) => {
    updateProfileForm.setFieldValue("country", "");
    updateProfileForm.setFieldValue("regions", "");
    updateProfileForm.setFieldValue("state", "");
    updateProfileForm.setFieldValue("city", "");
    dispatch(
      locationFromZipCodeAction({
        zip_code: e.target.value,
      }),
    );
  };

  const getRegionsById = (e) => {
    setRegion([]);
    setState([]);
    setCity([]);
    dispatch(getRegions(e.id));
  };

  const getStatesById = (e, is_country = false) => {
    setState([]);
    setCity([]);
    dispatch(getStates(e.id, is_country));
  };

  const getCitiesById = (e) => {
    setCity([]);
    dispatch(getCities(e.id));
  };

  const getProfilePic = (value) => {
    if (value.files[0]) {
      if (
        ALLOWED_PROFILE_IMAGES.includes(
          value.files[0].name?.split(".").pop().toLowerCase(),
        )
      ) {
        const readerProfile = new FileReader();
        readerProfile.readAsDataURL(value.files[0]);
        readerProfile.onload = (e) => {
          setProfileViewLink(e.target.result);
        };
      } else {
        setProfileViewLink(blankImage);
      }
    }
  };

  const deleteDocument = async (doc) => {
    const isConfirmed = await confirmAlert(
      "Confirm!",
      "Do you really want to delete?",
    );
    if (isConfirmed && doc?.id) {
      const removeDoc = mediaDocs.filter((item) => item.id !== doc.id);
      setMediaDocs(removeDoc);
      dispatch(
        removeMediaFromProfile({
          doc_id: doc.id,
        }),
      );
    }
  };

  const deleteUserAccount = async () => {
    const isConfirmed = await confirmAlert(
      "Confirm!",
      "<p>Are you sure you want to delete this account?</p>",
    );
    if (isConfirmed) {
      dispatch(deleteAccount());
    }
  };

  const deleteUploads = async (index) => {
    const isConfirmed = await confirmAlert(
      "Confirm!",
      "<p>Do you really want to delete?</p>",
    );
    if (isConfirmed) {
      setAttachments((prevAttachments) => {
        return prevAttachments.filter((_, i) => i !== index);
      });
    }
  };

  const onSuccessUploads = (data) => {
    setAttachments((prevAttachments) => [...prevAttachments, data]);
    successAlert("<p>File uploaded successfully.</p>");
    setShowUploader(false);
  };

  const onErrorUploads = (error) => {
    errorAlert(`<p>${JSON.stringify(error)}</p>`);
    setShowUploader(false);
  };

  const profileIncomplete = userData && userData.profile_incomplete === true;
  const missingFields = (userData && userData.missing_fields) || [];

  return (
    <Fragment>
      <h3>Edit Your Profile</h3>
      {profileIncomplete && missingFields.length > 0 && (
        <Alert color="warning" className="mb-2">
          <div className="alert-body">
            <strong>Action Required:</strong> Your profile is missing the
            following required fields:&nbsp;
            <strong>{missingFields.join(", ")}</strong>. Please fill them in and
            save to unlock all features.
          </div>
        </Alert>
      )}
      <Card>
        <CardBody>
          {getProfileLoading ? (
            <Alert className="mx-2 mt-2" color="primary">
              <div className="alert-body text-center">
                <Spinner style={{ width: "18px", height: "18px" }} /> Please
                wait...
              </div>
            </Alert>
          ) : (
            <Form onSubmit={updateProfileForm.handleSubmit} autoComplete="off">
              <Row>
                <FormGroup tag={Col} md="12">
                  <div className="item-img text-center mx-auto">
                    <Avatar
                      img={profileViewLink || blankImage}
                      imgHeight="150"
                      imgWidth="150"
                      className="avatar-img-fit-contain"
                    />
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <hr />
                </FormGroup>
              </Row>
              <Row>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="email"
                    title="Email"
                  />
                  <Input
                    type="email"
                    onBlur={updateProfileForm.handleBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.email}
                    name="email"
                    id="email"
                    placeholder="Email"
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.email &&
                        updateProfileForm.errors.email,
                    })}
                    autoComplete="off"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.email &&
                      updateProfileForm.errors.email}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="firstLastName"
                    title="First and Last Name"
                  />
                  <Input
                    name="firstLastName"
                    id="firstLastName"
                    onBlur={updateProfileForm.handleBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.firstLastName}
                    placeholder="First and Last Name"
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.firstLastName &&
                        updateProfileForm.errors.firstLastName,
                    })}
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.firstLastName &&
                      updateProfileForm.errors.firstLastName}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="profilePicture"
                    title="Change Photo"
                    isRequired={false}
                    msg="PNG, JPEG, JPG - Max 2MB"
                  />
                  <CustomInput
                    accept=".png, .jpg, .jpeg"
                    type="file"
                    id="profilePicture"
                    onBlur={updateProfileForm.handleBlur}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue(
                        "profilePicture",
                        e.target.files[0],
                      );
                      getProfilePic(e.target);
                    }}
                    className={classnames({
                      "input-file-error":
                        updateProfileForm.touched.profilePicture &&
                        updateProfileForm.errors.profilePicture,
                      "form-control-file": true,
                    })}
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="d-flex justify-content-between">
                    <div className="validation-err">
                      {updateProfileForm.touched.profilePicture &&
                        updateProfileForm.errors.profilePicture}
                    </div>
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="registeredDietitian"
                    title="Are you a Registered Dietitian?"
                  />
                  <Select
                    options={rdOption}
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    value={updateProfileForm.values.registeredDietitian}
                    onChange={(e) =>
                      updateProfileForm.setFieldValue("registeredDietitian", e)
                    }
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.registeredDietitian &&
                          updateProfileForm.errors.registeredDietitian
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.registeredDietitian &&
                      updateProfileForm.errors.registeredDietitian}
                  </div>
                </FormGroup>
                {updateProfileForm.values.registeredDietitian.value ===
                  "Other" && (
                  <FormGroup tag={Col} md="4">
                    <CustomLabel
                      formik={updateProfileForm}
                      id="otherRD"
                      title="Other"
                    />
                    <Input
                      name="otherRD"
                      id="otherRD"
                      onBlur={updateProfileForm.handleBlur}
                      onChange={updateProfileForm.handleChange}
                      value={updateProfileForm.values.otherRD}
                      placeholder="Other"
                      className={classnames({
                        "is-invalid":
                          updateProfileForm.touched.otherRD &&
                          updateProfileForm.errors.otherRD,
                      })}
                      disabled={getProfileLoading || updateProfileLoading}
                    />
                    <div className="validation-err">
                      {updateProfileForm.touched.otherRD &&
                        updateProfileForm.errors.otherRD}
                    </div>
                  </FormGroup>
                )}
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="licenceType"
                    title="Licence Type"
                  />
                  <Select
                    options={licenceOption}
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    value={updateProfileForm.values.licenceType}
                    onChange={(e) =>
                      updateProfileForm.setFieldValue("licenceType", e)
                    }
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.licenceType &&
                          updateProfileForm.errors.licenceType
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.licenceType &&
                      updateProfileForm.errors.licenceType}
                  </div>
                </FormGroup>
                {updateProfileForm.values.licenceType.value === "CDR" && (
                  <FormGroup tag={Col} md="4">
                    <CustomLabel
                      formik={updateProfileForm}
                      id="cdrNo"
                      title="CDR Number"
                    />
                    <Input
                      name="cdrNo"
                      id="cdrNo"
                      onBlur={updateProfileForm.handleBlur}
                      onChange={updateProfileForm.handleChange}
                      value={updateProfileForm.values.cdrNo}
                      placeholder="CDR Number"
                      className={classnames({
                        "is-invalid":
                          updateProfileForm.touched.cdrNo &&
                          updateProfileForm.errors.cdrNo,
                      })}
                      disabled={getProfileLoading || updateProfileLoading}
                    />
                    <div className="validation-err">
                      {updateProfileForm.touched.cdrNo &&
                        updateProfileForm.errors.cdrNo}
                    </div>
                  </FormGroup>
                )}
                {updateProfileForm.values.licenceType.value === "DOC" && (
                  <FormGroup tag={Col} md="4">
                    <CustomLabel
                      formik={updateProfileForm}
                      id="proofOfCertification"
                      title="Proof of Certification"
                      linkText="View Certificate"
                      link={certificateViewLink}
                    />
                    <CustomInput
                      accept=".png, .jpg, .jpeg, .pdf"
                      type="file"
                      name="proofOfCertification"
                      id="proofOfCertification"
                      onBlur={updateProfileForm.handleBlur}
                      onChange={(e) =>
                        updateProfileForm.setFieldValue(
                          "proofOfCertification",
                          e.target.files[0],
                        )
                      }
                      className={classnames({
                        "input-file-error":
                          updateProfileForm.touched.proofOfCertification &&
                          updateProfileForm.errors.proofOfCertification,
                        "form-control-file": true,
                      })}
                      disabled={getProfileLoading || updateProfileLoading}
                    />
                    <div className="validation-err">
                      {updateProfileForm.touched.proofOfCertification &&
                        updateProfileForm.errors.proofOfCertification}
                    </div>
                  </FormGroup>
                )}
                <FormGroup tag={Col} md="12">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="about"
                    title="About Me"
                  />
                  <Editor
                    editorState={aboutCompanyEditorState}
                    onEditorStateChange={(e) => {
                      setAboutCompanyEditorState(e);
                      const contentState = e.getCurrentContent();
                      if (contentState.hasText()) {
                        updateProfileForm.setFieldValue(
                          "about",
                          draftToHtml(convertToRaw(contentState)),
                        );
                      } else {
                        updateProfileForm.setFieldValue("about", "");
                      }
                    }}
                    toolbar={{
                      options: [
                        "inline",
                        "blockType",
                        "fontSize",
                        "list",
                        "colorPicker",
                        "link",
                        "remove",
                        "history",
                      ],
                      inline: {
                        options: ["bold", "italic", "underline"],
                      },
                      list: {
                        options: ["unordered", "ordered"],
                      },
                      blockType: {
                        options: ["Normal", "H1", "H2", "H3"],
                      },
                      link: {
                        showOpenOptionOnHover: false,
                      },
                      fontSize: {
                        options: [12, 14, 16, 18, 24, 36],
                      },
                    }}
                    stripPastedStyles={true}
                    editorStyle={{ minHeight: "250px" }}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.about &&
                      updateProfileForm.errors.about}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="gender"
                    title="Gender"
                  />
                  <Select
                    options={genderOption}
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    value={updateProfileForm.values.gender}
                    onChange={(e) =>
                      updateProfileForm.setFieldValue("gender", e)
                    }
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.gender &&
                          updateProfileForm.errors.gender
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.gender &&
                      updateProfileForm.errors.gender}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="yearsInPractice"
                    title="Years in Practice"
                  />
                  <Select
                    options={yearsInPracticeOptions}
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    value={updateProfileForm.values.yearsInPractice}
                    onChange={(e) =>
                      updateProfileForm.setFieldValue("yearsInPractice", e)
                    }
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.yearsInPractice &&
                          updateProfileForm.errors.yearsInPractice
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.yearsInPractice &&
                      updateProfileForm.errors.yearsInPractice}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="personal_attributes"
                    title="Attributes"
                    isRequired={false}
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    options={brandGoalsSelectValues?.personal_attributes}
                    isMulti={true}
                    isClearable={false}
                    value={updateProfileForm.values.attributes}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("attributes", e);
                    }}
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="workIn"
                    title="I work in"
                    msg="Select up to 3"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    options={brandGoalsSelectValues?.industry}
                    value={updateProfileForm.values.workIn}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("workIn", e);
                    }}
                    isMulti={true}
                    isClearable={false}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.workIn &&
                          updateProfileForm.errors.workIn
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.workIn &&
                      updateProfileForm.errors.workIn}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="specializeIn"
                    title="I specialize in"
                    msg="Select up to 3"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    options={brandGoalsSelectValues?.speciality}
                    isMulti={true}
                    isClearable={false}
                    value={updateProfileForm.values.specializeIn}
                    onChange={(e) =>
                      updateProfileForm.setFieldValue("specializeIn", e)
                    }
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.specializeIn &&
                          updateProfileForm.errors.specializeIn
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.specializeIn &&
                      updateProfileForm.errors.specializeIn}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <hr />
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="website"
                    title="Website"
                    isRequired={false}
                  />
                  <Input
                    name="website"
                    id="website"
                    onBlur={updateProfileForm.handleBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.website}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.website &&
                        updateProfileForm.errors.website,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.website &&
                      updateProfileForm.errors.website}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="facebook"
                    title="Facebook"
                    isRequired={false}
                  />
                  <Input
                    name="facebook"
                    id="facebook"
                    onBlur={handleSocialLinkBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.facebook}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.facebook &&
                        updateProfileForm.errors.facebook,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.facebook &&
                      updateProfileForm.errors.facebook}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="secondaryFacebook"
                    title="Secondary Facebook"
                    isRequired={false}
                  />
                  <Input
                    name="secondaryFacebook"
                    id="secondaryFacebook"
                    onBlur={handleSocialLinkBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.secondaryFacebook}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.secondaryFacebook &&
                        updateProfileForm.errors.secondaryFacebook,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.secondaryFacebook &&
                      updateProfileForm.errors.secondaryFacebook}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="instagram"
                    title="Instagram"
                    isRequired={false}
                  />
                  <Input
                    name="instagram"
                    id="instagram"
                    onBlur={handleSocialLinkBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.instagram}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.instagram &&
                        updateProfileForm.errors.instagram,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.instagram &&
                      updateProfileForm.errors.instagram}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="secondaryInstagram"
                    title="Secondary Instagram"
                    isRequired={false}
                  />
                  <Input
                    name="secondaryInstagram"
                    id="secondaryInstagram"
                    onBlur={handleSocialLinkBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.secondaryInstagram}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.secondaryInstagram &&
                        updateProfileForm.errors.secondaryInstagram,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.secondaryInstagram &&
                      updateProfileForm.errors.secondaryInstagram}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="twitter"
                    title="X (Twitter)"
                    isRequired={false}
                  />
                  <Input
                    name="twitter"
                    id="twitter"
                    onBlur={handleSocialLinkBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.twitter}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.twitter &&
                        updateProfileForm.errors.twitter,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.twitter &&
                      updateProfileForm.errors.twitter}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="pinterest"
                    title="Pinterest"
                    isRequired={false}
                  />
                  <Input
                    name="pinterest"
                    id="pinterest"
                    onBlur={handleSocialLinkBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.pinterest}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.pinterest &&
                        updateProfileForm.errors.pinterest,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.pinterest &&
                      updateProfileForm.errors.pinterest}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="linkedIn"
                    title="Linked In"
                    isRequired={false}
                  />
                  <Input
                    name="linkedIn"
                    id="linkedIn"
                    onBlur={handleSocialLinkBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.linkedIn}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.linkedIn &&
                        updateProfileForm.errors.linkedIn,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.linkedIn &&
                      updateProfileForm.errors.linkedIn}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="tiktok"
                    title="Tiktok"
                    isRequired={false}
                  />
                  <Input
                    name="tiktok"
                    id="tiktok"
                    onBlur={handleSocialLinkBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.tiktok}
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.tiktok &&
                        updateProfileForm.errors.tiktok,
                    })}
                    placeholder="URL"
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.tiktok &&
                      updateProfileForm.errors.tiktok}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="followers"
                    title="Reach"
                    isRequired={false}
                  />
                  <div className="d-flex align-items-center">
                    <Select
                      options={followersOptions}
                      className="react-select flex-grow-1"
                      classNamePrefix="select"
                      placeholder="Select range..."
                      isClearable={true}
                      value={updateProfileForm.values.followers || null}
                      onChange={(e) =>
                        updateProfileForm.setFieldValue("followers", e)
                      }
                      isDisabled={
                        syncFollowersLoading ||
                        getProfileLoading ||
                        updateProfileLoading
                      }
                    />
                    <Button
                      type="button"
                      color="primary"
                      outline
                      size="sm"
                      className="ml-1"
                      title="Sync followers from social media"
                      disabled={
                        syncFollowersLoading ||
                        getProfileLoading ||
                        updateProfileLoading
                      }
                      onClick={() =>
                        dispatch(
                          syncFollowers({
                            facebook_url: updateProfileForm.values.facebook,
                            secondary_facebook_url:
                              updateProfileForm.values.secondaryFacebook,
                            instagram_url: updateProfileForm.values.instagram,
                            secondary_instagram_url:
                              updateProfileForm.values.secondaryInstagram,
                            twitter_url: updateProfileForm.values.twitter,
                            tiktok_url: updateProfileForm.values.tiktok,
                            pinterest_url: updateProfileForm.values.pinterest,
                            linkedin_url: updateProfileForm.values.linkedIn,
                          }),
                        )
                      }
                    >
                      {syncFollowersLoading ? (
                        <Spinner size="sm" />
                      ) : (
                        <RefreshCw size={14} />
                      )}
                    </Button>
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <hr />
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="postalCode"
                    title="Postal Code"
                    isRequired={false}
                    msg={
                      locationFromZipCodeLoading ? "Finding Location..." : ""
                    }
                  />
                  <Input
                    type="text"
                    value={updateProfileForm.values.postalCode}
                    name="postalCode"
                    id="postalCode"
                    placeholder="Postal Code"
                    onChange={updateProfileForm.handleChange}
                    onBlur={(e) => {
                      updateProfileForm.handleBlur(e);
                      getLocationFromPostalCode(e);
                    }}
                    disabled={
                      getProfileLoading ||
                      updateProfileLoading ||
                      locationFromZipCodeLoading
                    }
                  />
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="country"
                    title="Country"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    options={country}
                    value={updateProfileForm.values.country}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("country", e);
                      updateProfileForm.setFieldValue("regions", "");
                      updateProfileForm.setFieldValue("state", "");
                      updateProfileForm.setFieldValue("city", "");
                      getStatesById(e, true);
                    }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.country &&
                          updateProfileForm.errors.country
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={
                      getProfileLoading ||
                      updateProfileLoading ||
                      locationFromZipCodeLoading
                    }
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.country &&
                      updateProfileForm.errors.country}
                  </div>
                </FormGroup>
                {/*<FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="regions"
                                        title="Regions"
                                    />
                                    <Select
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Please Select..."
                                        value={updateProfileForm.values.regions}
                                        options={region}
                                        onChange={(e) => {
                                            updateProfileForm.setFieldValue('regions', e)
                                            updateProfileForm.setFieldValue('state', '')
                                            updateProfileForm.setFieldValue('city', '')
                                            getStatesById(e)
                                        }}
                                        styles={{
                                            control: (baseStyles) => ({
                                                ...baseStyles,
                                                borderColor: updateProfileForm.touched.regions && updateProfileForm.errors.regions ? 'red' : baseStyles.borderColor
                                            })
                                        }}
                                        isDisabled={getProfileLoading || updateProfileLoading || locationFromZipCodeLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.regions && updateProfileForm.errors.regions}</div>
                                </FormGroup>*/}
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="state"
                    title="State"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    value={updateProfileForm.values.state}
                    options={state}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("state", e);
                      updateProfileForm.setFieldValue("city", "");
                      getCitiesById(e);
                    }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.state &&
                          updateProfileForm.errors.state
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={
                      getProfileLoading ||
                      updateProfileLoading ||
                      locationFromZipCodeLoading
                    }
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.state &&
                      updateProfileForm.errors.state}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="city"
                    title="City"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    value={updateProfileForm.values.city}
                    options={city}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("city", e);
                    }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.city &&
                          updateProfileForm.errors.city
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={
                      getProfileLoading ||
                      updateProfileLoading ||
                      locationFromZipCodeLoading
                    }
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.city &&
                      updateProfileForm.errors.city}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <hr />
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="mainGoal"
                    title="What is your main goal for joining The RD Link?"
                  />
                  <Input
                    type="textarea"
                    onBlur={updateProfileForm.handleBlur}
                    onChange={updateProfileForm.handleChange}
                    value={updateProfileForm.values.mainGoal}
                    name="mainGoal"
                    id="mainGoal"
                    placeholder="Your Answer..."
                    rows="5"
                    className={classnames({
                      "is-invalid":
                        updateProfileForm.touched.mainGoal &&
                        updateProfileForm.errors.mainGoal,
                    })}
                    disabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.mainGoal &&
                      updateProfileForm.errors.mainGoal}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <hr />
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <p className="font-weight-bold">
                    Are there certain types of brands that you are particularly
                    interested in connecting with?
                  </p>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="companyValues"
                    title="Company Values"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    options={brandCompanySelectValues?.values}
                    isMulti={true}
                    isClearable={false}
                    value={updateProfileForm.values.companyValues}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("companyValues", e);
                    }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.companyValues &&
                          updateProfileForm.errors.companyValues
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.companyValues &&
                      updateProfileForm.errors.companyValues}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="specialDiet"
                    title="Special Diet"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    options={brandCompanySelectValues?.special_diet}
                    isMulti={true}
                    isClearable={false}
                    value={updateProfileForm.values.specialDiet}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("specialDiet", e);
                    }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.specialDiet &&
                          updateProfileForm.errors.specialDiet
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.specialDiet &&
                      updateProfileForm.errors.specialDiet}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="foodCategory"
                    title="Food Category"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    options={brandCompanySelectValues?.category}
                    isMulti={true}
                    isClearable={false}
                    value={updateProfileForm.values.foodCategory}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("foodCategory", e);
                    }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.foodCategory &&
                          updateProfileForm.errors.foodCategory
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.foodCategory &&
                      updateProfileForm.errors.foodCategory}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="primarilyInterested"
                    title="Are you primarily interested in?"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    options={rdPrimarilyGoalsValues?.primarily_interest}
                    isMulti={false}
                    isClearable={false}
                    value={updateProfileForm.values.primarilyInterested}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("primarilyInterested", e);
                    }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.primarilyInterested &&
                          updateProfileForm.errors.primarilyInterested
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.primarilyInterested &&
                      updateProfileForm.errors.primarilyInterested}
                  </div>
                </FormGroup>
                <FormGroup tag={Col} md="4">
                  <CustomLabel
                    formik={updateProfileForm}
                    id="hearAbout"
                    title="How did you hear about The RD Link?"
                  />
                  <Select
                    className="react-select"
                    classNamePrefix="select"
                    placeholder="Please Select..."
                    value={updateProfileForm.values.hearAbout}
                    onChange={(e) => {
                      updateProfileForm.setFieldValue("hearAbout", e);
                      updateProfileForm.setFieldValue("otherPlatform", "");
                    }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor:
                          updateProfileForm.touched.hearAbout &&
                          updateProfileForm.errors.hearAbout
                            ? "red"
                            : baseStyles.borderColor,
                      }),
                    }}
                    options={hearAboutOption}
                    isDisabled={getProfileLoading || updateProfileLoading}
                  />
                  <div className="validation-err">
                    {updateProfileForm.touched.hearAbout &&
                      updateProfileForm.errors.hearAbout}
                  </div>
                </FormGroup>
                {updateProfileForm.values.hearAbout.value === "Other" && (
                  <FormGroup tag={Col} md="4">
                    <CustomLabel
                      formik={updateProfileForm}
                      id="otherPlatform"
                      title="Where did you hear about us?"
                    />
                    <Input
                      type="text"
                      onBlur={updateProfileForm.handleBlur}
                      onChange={updateProfileForm.handleChange}
                      value={updateProfileForm.values.otherPlatform}
                      name="otherPlatform"
                      id="otherPlatform"
                      placeholder="Your answer..."
                      className={classnames({
                        "is-invalid":
                          updateProfileForm.touched.otherPlatform &&
                          updateProfileForm.errors.otherPlatform,
                      })}
                      disabled={getProfileLoading || updateProfileLoading}
                    />
                    <div className="validation-err">
                      {updateProfileForm.touched.otherPlatform &&
                        updateProfileForm.errors.otherPlatform}
                    </div>
                  </FormGroup>
                )}
                <FormGroup tag={Col} md="12">
                  <hr />
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <h6 className="font-weight-bolder bg-light p-1">
                    Upload Image, PDF or Video
                  </h6>
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <Button.Ripple
                    color="primary"
                    type="button"
                    disabled={getProfileLoading || updateProfileLoading}
                    onClick={() => setShowUploader(true)}
                  >
                    <File size="16" /> Choose File
                  </Button.Ripple>
                  {attachments?.length > 0 && (
                    <>
                      <Table className="mt-1 mb-1 table-bordered">
                        <thead>
                          <tr>
                            <th width={1}>Sr.</th>
                            <th>Uploads</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {attachments.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.title}</td>
                              <td>
                                <Button.Ripple
                                  color="danger"
                                  type="button"
                                  size="sm"
                                  onClick={() => deleteUploads(index)}
                                  disabled={
                                    getProfileLoading || updateProfileLoading
                                  }
                                >
                                  <Trash size="14" /> Delete
                                </Button.Ripple>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  )}
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <hr />
                </FormGroup>
                {mediaDocs.length > 0 && (
                  <>
                    <FormGroup tag={Col} md="12">
                      <h6 className="font-weight-bolder bg-light p-1">
                        Attachments
                      </h6>
                      <div className="mt-3 d-flex flex-wrap">
                        {mediaDocs.map((item, index) => (
                          <div key={index}>
                            {(item?.document_type === "png" ||
                              item?.document_type === "jpg" ||
                              item?.document_type === "jpeg") && (
                              <div className="media-img media-file">
                                <div className="remove-icon">
                                  <button
                                    type="button"
                                    className="btn btn-link p-0 text-danger"
                                    onClick={() => deleteDocument(item)}
                                  >
                                    <X size={16} />
                                  </button>
                                </div>
                                <div className="download-icon">
                                  <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    onClick={() =>
                                      setImageViewer({
                                        show: true,
                                        src: item.document_url,
                                      })
                                    }
                                  >
                                    <Eye size={16} />
                                  </button>
                                </div>
                                <div className="name-wrap">
                                  <img
                                    className="rounded img-fit-contain"
                                    src={item.document_url}
                                    alt={item.document_name}
                                    style={{ height: "100px", width: "100px" }}
                                  />
                                  <p className="text-truncate mt-1">
                                    <strong>{item.document_name}</strong>
                                  </p>
                                </div>
                              </div>
                            )}
                            {item?.document_type === "pdf" && (
                              <div className="media-img media-file">
                                <div className="remove-icon">
                                  <button
                                    type="button"
                                    className="btn btn-link p-0 text-danger"
                                    onClick={() => deleteDocument(item)}
                                  >
                                    <X size={16} />
                                  </button>
                                </div>
                                <div className="download-icon cursor-pointer">
                                  <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    onClick={() =>
                                      setPdfViewer({
                                        show: true,
                                        url: item.document_url,
                                        filename: item.document_name,
                                      })
                                    }
                                  >
                                    <Eye size={16} />
                                  </button>
                                </div>
                                <div className="name-wrap">
                                  <img
                                    className="rounded png-icon-img"
                                    src={PDF}
                                    alt="PDF Icon"
                                  />
                                  <p className="text-truncate mt-1">
                                    <strong>{item.document_name}</strong>
                                  </p>
                                </div>
                              </div>
                            )}
                            {item?.document_type === "mp4" && (
                              <div className="media-img media-file">
                                <div className="remove-icon">
                                  <button
                                    type="button"
                                    className="btn btn-link p-0 text-danger"
                                    onClick={() => deleteDocument(item)}
                                  >
                                    <X size={16} />
                                  </button>
                                </div>
                                <div className="download-icon cursor-pointer">
                                  <button
                                    type="button"
                                    className="btn btn-link p-0"
                                    onClick={() =>
                                      setVideoPlayer({
                                        show: true,
                                        url: item.document_url,
                                        filename: item.document_name,
                                      })
                                    }
                                  >
                                    <Eye size={16} />
                                  </button>
                                </div>
                                <div className="name-wrap text-center">
                                  <Video className="text-primary" size={90} />
                                  <p className="text-truncate">
                                    <strong>{item.document_name}</strong>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </FormGroup>
                    <FormGroup tag={Col} md="12">
                      <hr />
                    </FormGroup>
                  </>
                )}
              </Row>
              <Row>
                <FormGroup
                  tag={Col}
                  md="12"
                  className="align-items-center d-flex justify-content-end"
                >
                  <div>
                    <Button.Ripple
                      type="submit"
                      color="primary"
                      className="btn btn-success"
                      disabled={getProfileLoading || updateProfileLoading}
                    >
                      {updateProfileLoading ? (
                        <span>
                          <Spinner style={{ width: "16px", height: "16px" }} />{" "}
                          Updating Profile...
                        </span>
                      ) : (
                        <span>
                          Update Profile <ArrowRight size="18" />
                        </span>
                      )}
                    </Button.Ripple>
                  </div>
                </FormGroup>
              </Row>
              <Row>
                <FormGroup tag={Col} md="12">
                  <hr />
                </FormGroup>
                <FormGroup tag={Col} md="12">
                  <div className="d-flex bg-light p-2">
                    <div className="mr-2 text-danger">
                      <Trash2 size="80" />
                    </div>
                    <div>
                      <p className="mb-0 text-primary">
                        <strong>Unhappy?</strong>
                      </p>
                      <p>
                        Want to delete this account? All your information will
                        be lost and unrecoverable.
                      </p>
                      <button
                        type="button"
                        className="btn btn-link p-0 text-danger"
                        onClick={deleteUserAccount}
                      >
                        <strong>Delete my account.</strong>
                      </button>
                    </div>
                  </div>
                </FormGroup>
              </Row>
            </Form>
          )}
        </CardBody>
      </Card>
      <Uploader
        show={showUploader}
        hide={() => setShowUploader(false)}
        onSuccess={(data) => onSuccessUploads(data)}
        onError={(error) => onErrorUploads(error)}
      />
      <ImageViewer
        show={imageViewer.show}
        hide={() => setImageViewer({ show: false, src: "" })}
        images={[{ src: imageViewer.src }]}
      />
      <PdfViewer
        show={pdfViewer.show}
        url={pdfViewer.url}
        filename={pdfViewer.filename}
        hide={() => setPdfViewer({ show: false, url: "", filename: "" })}
      />
      <VideoPlayer
        show={videoPlayer.show}
        url={videoPlayer.url}
        filename={videoPlayer.filename}
        hide={() => setVideoPlayer({ show: false, url: "", filename: "" })}
      />
    </Fragment>
  );
};

export default RDEditProfile;
